import { HttpClient, HttpParams } from "@angular/common/http";
import { inject, Injectable, signal } from "@angular/core";
import { Router } from "@angular/router";
import { BASE_URI } from "app/app.config";

@Injectable({
  providedIn: "root",
})
export class CoreService {
  private baseUrl = BASE_URI.URL;

  private readonly router = inject(Router);

  constructor(
    private http: HttpClient
  ) { }

  private readonly _userProfile =
    signal<any>(null);

  readonly userProfile =
    this._userProfile.asReadonly();

  setUserProfile(user: any): void {
    this._userProfile.set(user);
  }

  getUserProfile(): any {
    return this._userProfile();
  }

  clearUserProfile(): void {
    this._userProfile.set(null);
  }

  getClients() {
    return this.http.get(`${BASE_URI.URL}/getClientCount`)
  }

  getAllUsersCount() {
    return this.http.get(`${BASE_URI.URL}/getTotalUserCount`)
  }

  getDocumentCount() {
    return this.http.get(`${BASE_URI.URL}/getTotalDocumentCount`)
  }

  getMostAskQuestions(){
    return this.http.get(`${BASE_URI.URL}/chat/most-asked-questions`)
  }

  getUploadDocumentList(){
    return this.http.get(`${BASE_URI.URL}/chat/recentlyUploadDocument`);
  }

  preHttpParams(payload: any): HttpParams {

    let params = new HttpParams();

    Object.keys(payload ?? {}).forEach(key => {

      const value = payload[key];

      if (
        value !== null &&
        value !== undefined &&
        value !== ''
      ) {
        params = params.set(
          key,
          String(value)
        );
      }
    });

    return params;
  }
}
